// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import { modalButtonsActionStyles } from "@keller/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

orderUploadErrorsModalStyles.descriptionText = {
    css: css`
        margin-bottom: 15px;
    `,
};

orderUploadErrorsModalStyles.dataTable = {};

orderUploadErrorsModalStyles.modal = {};

orderUploadErrorsModalStyles.buttonsWrapper = {
    css: css`
        padding-top: 30px;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
    `,
};

orderUploadErrorsModalStyles.cancelUploadButton = modalButtonsActionStyles.cancelButton;

orderUploadErrorsModalStyles.continueUploadButton = modalButtonsActionStyles.submitButton;
